import {
  initialState,
  Actions,
  State,
  EDIT_CONTENT,
  EDIT_CONTENT_SUCCESS,
  EDIT_CONTENT_ERROR,
  RESET_EDIT_CONTENT,
} from '../../types/content/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_CONTENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_CONTENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_CONTENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_CONTENT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
